// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"H3-z","displaySixCardTiles":"I3-z"};